export default {
  container: {
    maxWidth: ['100%', '725px', '896px'],
    margin: '0 auto',
  },
  title: {
    fontFamily: 'spoqaBold',
    color: 'tmBlue',
    fontSize: '24px',
    marginBottom: ['4px', '8px', '10px'],
    marginTop: ['60px', '0'],
  },
  subTitle: {
    fontSize: '14px',
    margin: '0 auto',
  },
  contentWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    gap: ['19px', '40px 35px', '52px 53px'],
    maxWidth: ['320px', '100%'],
    margin: ['40px auto 0 auto', '40px auto 0 auto', '33px auto 0 auto'],
  },
  imageWrapper: {
    width: ['94px', '212px', '262px'],
    height: ['143px', '324px', '399px'],
    cursor: 'pointer',
    borderRadius: '8px',
    boxShadow: '4px 4px 8px 0px rgba(0, 0, 0, 0.10)',
    overflow: 'hidden',

    img: {
      width: ['94px', '212px', '262px'],
      height: ['143px', '324px', '399px'],
      objectFit: 'cover',
    },
  },
  seeMoreButton: {
    display: 'flex',
    justifyContent: 'center',
    button: {
      padding: '5px 13px',
      borderRadius: '18px',
      color: 'white',
      background: 'rgba(0, 0, 0, 0.30)',
      marginTop: ['40px', '53px'],
      cursor: 'pointer',

      '&:hover': {
        background: 'rgba(0, 0, 0, 0.40)',
      },
    },
  },
  lightbox: (lightBoxTitle) => ({
    '.yarl__carousel': {
      zIndex: 2,
    },
    '.yarl__toolbar': {
      width: '100%',
      height: '100%',
      display: 'block',

      '[aria-label="Download"]': {
        position: 'absolute',
        bottom: ['calc(100% / 2 - 250px)', 'calc(100% / 2 - 280px)'],
        right: ['calc(100% / 2 - 175px)', 'calc(100% / 2 - 250px)'],
      },
      '[aria-label="Close"]': {
        left: '5px',
        position: 'absolute',
      },
    },
    '.yarl__counter': {
      top: 'calc(100% - 95%)',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      fontSize: '20px',
      fontFamily: 'spoqaRegular',
      ...(lightBoxTitle && {
        '&:before': {
          content: `"${lightBoxTitle}"`,
          display: 'block',
          marginRight: '10px',
        },
      }),
    },
    '.yarl__container': {
      backgroundImage: `url(../../static/phone_preview.png)`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: ['240px auto', 'auto'],
      minHeight: '650px',

      '.yarl__slide:before': {
        content: '""',
        display: 'block',
        backgroundImage: `url(../../static/phone_preview_time.png)`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: [
          'calc(100% / 2 - 10px) calc(100% / 2 - 140px)',
          'center calc(100% / 2 - 150px)',
        ],
        backgroundSize: ['280px', 'inherit'],
        position: 'absolute',
        width: '339px',
        height: '100%',
        zIndex: 1,
        top: 0,
      },

      '.yarl__slide_image': {
        width: ['219px', '258px'],
        height: ['auto', '544px'],
        borderRadius: ['20px', '30px'],
      },
    },
    '.yarl__navigation_next, .yarl__navigation_prev, .yarl__button': {
      zIndex: 3,
    },
  }),
}
